import { i18nPrice } from '@shared/fondof-fn/format/price'
import { parseAmount } from '@shared/fondof-fn/parse/amount'
import type {
  CartDiscountAllocationFragment,
  CartDiscountCodeFragment,
} from '@shared/types/storefront/graphql'

export const toCartDiscount = (code: CartDiscountCodeFragment) => {
  return {
    applicable: code.applicable,
    code: code.code,
  }
}

export const toCartDiscountAllocation = (
  discountAllocation: CartDiscountAllocationFragment
) => {
  const discount = parseAmount(discountAllocation.discountedAmount.amount)

  return {
    discount,
    discountParsed: i18nPrice(
      discount,
      discountAllocation.discountedAmount.currencyCode
    ),
  }
}
